module.exports = __webpack_public_path__ + "static/media/mastercard.f53b45c0.png";